export default {
  // 主页面
  collaborationPage: "合作管理",
  coldEmail: "邮件营销",
  reportAndPayout: "报告与结算",
  report: "报告",
  budgetLabel: "预算",
  campaignInfoPage: "计划信息",
  campaignInfo: "计划信息",

  // 状态相关
  status: {
    active: "进行中",
    paused: "已暂停",
    draft: "草稿",
    ended: "已结束",
    predicting: "预测中",
    completed: "已完成",
    cancelled: "已取消",
    reviewing: "审核中",
    rejected: "未通过",
  },

  // 操作按钮
  actions: {
    pause: "暂停",
    resume: "继续",
    edit: "编辑",
    close: "关闭",
    save: "保存",
    cancel: "取消",
    confirm: "确认",
    submit: "提交",
    reset: "重置",
    back: "返回",
  },

  // 预算相关
  budget: {
    title: "预算",
    currentBudget: "当前预算",
    remainingBudget: "剩余预算",
    spentBudget: "已用预算",
    changeBudget: "调整预算",
    budgetLimit: "预算上限",
    monthlyBudget: "月度预算",
    totalBudget: "总预算",
    influencerBudget: "达人预算",
    affiliateBudget: "分销预算",
    coldEmailBudget: "邮件营销预算",
    continueBudget: "继续使用预算",
    cancelBudget: "取消预算",
    updateBudget: "更新预算",
    budgetHistory: "预算记录",
    budgetCycle: "预算周期",
    nextCycle: "下个周期",
    currentCycle: "当前周期",
  },

  // 反馈相关
  feedback: {
    title: "意见反馈",
    submitFeedback: "提交反馈",
    submitFeedbackHere: "在此提交反馈",
    pleaseEnterFeedback: "请填写您的反馈",
    feedbackPlaceholder: "告诉我，如何进一步优化本次活动的达人匹配效果？",
    feedbackSubmitted: "反馈提交成功，感谢您的支持！",
    submitNewFeedback: "再提交一条反馈",
    sendFeedback: "发送反馈",
  },

  // 指南卡片
  guide: {
    title: "活动指南",
    description: "学习如何优化设定营销计划",
    viewGuide: "查看指南",
    instructions: "操作说明",
  },

  // 暂停相关
  pause: {
    resumeCampaign: "恢复计划",
    title: "由于处于非活动状态，您的活动",
    title2: "已暂停",
    content: "要继续匹配并推进流程，请立即恢复计划。",
  },

  // 预算不足提醒
  budgetAlert: {
    title: "预算提醒",
    insufficientBudget: "当前周期预算不足",
    addBudget: "追加预算",
    upgradePlan: "升级方案",
    lowBudgetTitle: "“{name}” 的预算不足：{campaignBudget}中已使用 {costToDate}",
    lowBudgetDesc:
      "预算直接影响可邀请的达人数量和单价上限，提升预算，解锁更多合作机会，获得更佳效果。",
    pausedTitle: "该活动当前已暂停",
    pausedDesc: "如需优化活动设置或启动新活动，请随时联系我们的客户支持团队。",
  },

  // 预算页面相关
  budgetPage: {
    title: "预算",
    renewalSuccessful: "续费成功！",
    accountFrozen: "您的账户已被冻结",
    changeSuccess: "预算调整成功",
    cancelSuccess: "活动取消成功",
    raiseMaxCpm: "提升最高 CPM 以充分使用广告预算",
    currentAdSpend: "当前广告支出：{cost}",
    youtubeDedicated: "YouTube 全片：{price}",
    youtubeIntegrated: "YouTube 插片：{price}",
    tiktokVideo: "TikTok 视频：{price}",
    influencerMarketingBudget: "达人营销预算",
    viewBillingHistory: "查看账单记录",
    costToDate: "累计支出",
    costToDateDescription: "包含达人费用、平台服务费及适用交易费。",
    budget: "预算",
    budgetTooltip: "您的预算决定了 AhaCreator 可邀请的达人数。",
    currencyUnit: "USD",
    affiliateRecruitmentBudget: "分销招募预算",
    continueWithBudget: "继续使用 {budget} 预算",
    continueAndModify: "继续并修改预算",
    cancel: "取消",
    renewCampaign: "续费活动",
    coldEmailBudget: "邮件营销预算",
    continueModifyTitle: "继续并修改预算",
    confirm: "确认",
    monthlySpendingLimit:
      "月度支出上限为您在单月内用于活动的最高金额。我们会根据当月确认的预期点击量进行扣费。",
    termination: "终止",
    cancelCampaign: "确定取消此活动？",
    cancelCampaignDesc: "取消后将无法恢复，请谨慎操作。",
    change: "修改",
    yes: "是",
    no: "否",
    instagramReel: "Instagram Reels：{price}",
    twitterPost: "Twitter / X 帖子：{price}",
    linkedinPost: "LinkedIn 帖子：{price}",
    influencerMarketingBudgetTooltip: "您的预算决定了可以邀请多少达人参与活动。如果您希望 AI 匹配更多达人并最大化活动效果，可以提高预算。",
  },

  // 审核拒绝提醒
  reviewAlert: {
    title: "审核提醒",
    campaignRejected: "该营销计划未通过审核",
    reviewReason: "审核原因",
    resubmit: "重新提交",
  },

  // 充值相关
  recharge: {
    title: "限时优惠",
    description: "活动上线后 5 天内充值，可获赠广告额度。支持随时 100% 退款。",
    rechargeNow: "立即充值",
    skipForNow: "暂不使用",
    depositNow: "立即充值 {total}，获赠 {credits} 广告额度",
  },

  // 最大CPM相关
  maxCpm: {
    title: "最高 CPM",
    platform: "平台",
    price: "价格",
    youtubeDedicated: "YouTube 专属视频",
    youtubeIntegrated: "YouTube 插片视频",
    tiktokVideo: "TikTok 视频",
    instagramReel: "Instagram Reels",
    instagramCarouselPost: "Instagram 图文贴子",
    twitterPost: "Twitter 帖子",
    linkedinPost: "LinkedIn 帖子",
  },

  // 时间相关
  time: {
    currentTime: "当前时间",
    startDate: "开始日期",
    endDate: "结束日期",
    progress: "进度",
    remainingDays: "剩余天数",
  },

  // 消息提示
  messages: {
    campaignPaused: "活动已暂停",
    campaignResumed: "活动已恢复",
    budgetUpdated: "预算更新成功",
    feedbackSubmitted: "反馈提交成功，感谢您的支持！",
    operationFailed: "出了一点小问题，请稍后再试",
    pleaseWait: "请稍候...",
    loading: "加载中...",
    noData: "暂无数据",
  },

  // 表单验证
  validation: {
    required: "此字段为必填项",
    invalidNumber: "请输入有效的数字",
    invalidEmail: "请输入有效的邮箱地址",
    minLength: "至少输入 {min} 个字符",
    maxLength: "最多可输入 {max} 个字符",
  },

  // 通用
  common: {
    yes: "是",
    no: "否",
    ok: "好的",
    close: "关闭",
    loading: "加载中",
    error: "错误",
    success: "成功",
    warning: "提醒",
    info: "提示",
    confirm: "确认",
    cancel: "取消",
    delete: "删除",
    edit: "编辑",
    view: "查看",
    add: "添加",
    remove: "移除",
    searchData: "搜索",
    filterData: "筛选",
    sort: "排序",
    refresh: "刷新",
    exportData: "导出",
    import: "导入",
    downloadData: "下载",
    upload: "上传",
  },

  // 主页面相关
  mainPage: {
    campaignCanceled: "营销计划已取消",
    campaignCanceledDescription:
      "很遗憾，您的活动因支付未完成而被取消。但已建立的合作仍可继续。如需帮助，请联系支持团队。",
    fold: "收起",
    headInstructions: "使用指南",
    headInstructionsDesc: "活动启动后，您可以期待以下内容",
    headAcademy: "AhaCreator 学院",
    headAcademyDesc: "在 YouTube 观看完整教程",
  },

  // 合作页面相关
  collaboration: {
    creatorList: "达人列表",
    invitedList: "已邀请达人",
    todoList: "待办事项",
    searchCollaboration: "搜索",
    filterCollaboration: "筛选",
    statusCollaboration: "状态",
    platformCollaboration: "平台",
    regionCollaboration: "地区",
    languageCollaboration: "语言",
    nameCollaboration: "姓名",
    followers: "粉丝数",
    engagement: "互动率",
    priceCollaboration: "报价",
    actionsCollaboration: "操作",
    invite: "邀请",
    accept: "接受",
    reject: "拒绝",
    pendingCollaboration: "待处理",
    approved: "已批准",
    rejected: "已拒绝",
    completed: "已完成",
    viewCollaboration: "查看",
    editCollaboration: "编辑",
    deleteCollaboration: "删除",
    downloadCollaboration: "下载",
    exportCollaboration: "导出",
    noDataCollaboration: "暂无数据",
    loadingCollaboration: "加载中...",
    errorCollaboration: "出错了",
    successCollaboration: "操作成功",
    // 标签页选项
    invitedInfluencers: "已邀请达人",
    establishedCollaborations: "已建立合作",
    confirmInviteList: "待确认邀约列表",
    all: "全部",
    ahaPicks: "Aha 精选",
    quotedInfluencers: "已报价达人",
    priceNegotiation: "价格谈判",
    pendingKickoff: "待启动",
    scriptUnderProduction: "脚本制作中",
    contentUnderProduction: "内容制作中",
    pendingPublish: "待发布",
    adsPublished: "广告已发布",
    canceled: "已取消",
    // 新增翻译键
    inviteTemplates: "邀约模版",
    influencer: "达人营销",
    inviteEmailTemplate: {
      button: "邀请邮件模板",
      title: "邀请邮件模板",
      description: "AhaCreator 拥有数万种多样化的邮件模板。这些模板已在数百万真实订单中得到验证，始终提供最强的响应和转化表现。以下是 5 个邀请示例：",
      tooltip: "完成达人邀请后，邮件模板查看功能将自动启用。",
    },
    trialBatchTip:
      "AhaCreator 已为您邀请了一批试用达人，您将收到 3–5 个初始申请。要解锁完整访问，请",
    startCollaboration: "与任意达人开始合作",
    or: "或",
    depositBudget: "充值营销预算",
    earnMoreCredits: "正式启动您的营销计划",
    campaignProgress: {
      reviewCampaign: "活动已上线",
      matchInfluencers: "匹配 & 邀约",
      negotiatePriceAndSettleContract: "达人感兴趣",
      viewInfluencerApplication: "报价 & 申请",
      reviewCampaignActiveDesc: "平台将在 24 小时内审核您的活动",
      reviewCampaignAfterDesc: "您的活动已上线，准备进行外联",
      matchInfluencersBeforeDesc: "最佳匹配的达人将被匹配并邀请给您",
      haveBeenMatched: "达人已匹配 · 邀约已发送",
      matchInfluencersActiveDesc: "AI 正在为你筛选顶级达人，并自动发送合作邀请",
      negotiatePriceAndSettleContractBeforeDesc: "感兴趣的达人将出现在这里",
      negotiatePriceAndSettleContractActiveDesc: "已表示感兴趣",
      viewInfluencerApplicationBeforeDesc: "达人报价将出现在“已报价达人”标签页下方",
      viewInfluencerApplicationActiveDesc: "已提交报价 · 等待您的审核",
      viewPlatformDetails: "查看平台详情",
      viewApplication: "查看报价",
    },
    ahaPicksTooltip: "从 AhaCreator 注册达人池中为您挑选最佳匹配，帮助您更快匹配达人。",
    pendingKickoffTooltip: "你已确认达人合作，等待达人启动内容制作。",
  },

  // 活动信息页面相关
  campaignInfoDetails: {
    title: "计划信息",
    basicInfo: "基本信息",
    settings: "设置",
    details: "详情",
    statusCampaignInfo: "状态",
    startDate: "开始日期",
    endDate: "结束日期",
    budgetCampaignInfo: "预算",
    objective: "目标",
    target: "受众",
    platformCampaignInfo: "平台",
    audience: "受众",
    creative: "创意",
    editCampaignInfo: "编辑",
    saveCampaignInfo: "保存",
    cancelCampaignInfo: "取消",
    deleteCampaignInfo: "删除",
    viewCampaignInfo: "查看",
    noDataCampaignInfo: "暂无数据",
    loadingCampaignInfo: "加载中...",
    errorCampaignInfo: "出错了",
  },

  // 活动详情面板相关
  panel: {
    reminder: "提醒",
    editWarning: "计划已上线，部分信息暂不可编辑。",
    edit: "编辑",
    resumed: "已恢复",
    objective: "目标",
    internalNote: "内部备注",
    startedOn: "开始于",
    currentCycle: "当前周期",
    editCampaign: "编辑活动",
    resume: "继续",
    pause: "暂停",
    paused: "已暂停",
    reject: "拒绝",
    approve: "批准",
    rejectTitle: "拒绝",
    rejectCampaign: "拒绝营销计划",
    rejectionReason: "拒绝原因",
    rejectionReasonDesc: "请向广告主说明拒绝原因。",
    enterRejectReason: "请输入拒绝原因",
    successfully: "操作成功！",
  },

  // 最大CPM预算相关
  maxCpmBudget: {
    headerTitle: "提升 CPM，充分利用广告预算",
    closeText: "稍后再说",
    description:
      "基于当前最高 CPM 设置，您的广告支出为 {cost} 美元。为更充分地使用预算，建议将最高 CPM 调整为：",
    approveChanges: "是否同意以上调整？",
    platforms: {
      youtubeDedicated: "YouTube 专属视频",
      youtubeIntegrated: "YouTube 插播视频",
      tiktokVideo: "TikTok 视频",
      instagramReel: "Instagram Reels",
      twitterPost: "Twitter / X 帖子",
      linkedinPost: "LinkedIn 帖子",
    },
  },

  // 受众页面相关
  audience: {
    title: "受众",
    edit: "编辑",
    mode: "模式",
    smartMatchMode: "智能匹配模式",
    manualMode: "手动模式",
    smartMatchDesc:
      "交给 AI 代理：优先触达高优先级受众；若达人不足，将逐步扩大覆盖范围。",
    manualModeDesc:
      "手动选择受众：可参考平台推荐；如达人不足，需要您手动补充更多受众。",
    showMore: "展开更多",
  },

  // 活动创意页面相关
  campaignIdeas: {
    title: "营销创意",
    edit: "编辑",
  },

  // 活动信息编辑页面相关
  campaignInformationEdit: {
    title: "计划信息",
    cancel: "取消",
    save: "保存",
    campaignName: "计划名称",
    internalNote: "内部备注",
    influencerBudget: "达人预算",
    affiliateRecruitmentBudget: "分销招募预算",
    coldEmailOutreachBudget: "邮件营销外联预算",
    platform: "平台",
    country: "国家/地区",
    languages: "语言",
    influencerMarketingPostDate: "达人营销发布日期",
    businessName: "品牌/公司名称",
    website: "网站",
    benchmarkBrands: "对标品牌",
    productIntro: "产品简介",
    coreSellingPoints: "核心卖点",
    coreAudiences: "核心产品受众",
    budgetPerInfluencer: "单个达人预算",
    maximumCpm: "最高 CPM",
    selectAll: "全选",
    flexiblePostTime: "灵活发布时间：达人内容通过后即可发布。",
    fixedPostTime: "固定发布时间：达人需在指定时间窗口内发布。",
    letAiAgentSetCpm: "交由 AI 代理设置 CPM",
    setMaximumCpmManually: "手动设置最高 CPM",
    regenerateOptimizedAudiences: "重新生成优化受众？",
    regenerateAudiencesDesc:
      "检测到您修改了可能影响优化受众的信息，是否立即重新生成？",
    notNow: "暂不",
    confirm: "确认",
    gotIt: "知道了",
    campaignUpdated: "活动已更新！我们将按最新设置邀请达人，申请将很快到达。",
    // 表单验证消息
    pleaseEnterCampaignName: "请输入计划名称",
    maximum50Characters: "最多可输入 50 个字符。",
    pleaseSelectBudget: "请选择预算",
    pleaseSelectAtLeastOnePlatform: "请至少选择一种平台内容类型",
    pleaseSelectAtLeastOneRegion: "请至少选择一个地区",
    pleaseEnterBenchmarkBrands: "请输入对标品牌",
    pleaseEnterElevatorPitch: "请输入电梯陈述",
    pleaseSelectPostDate: "请选择发布日期",
    pleaseEnterBusinessName: "请输入品牌/公司名称",
    campaignIntroduction: "活动简介",
    // 提示信息
    platformTooltip: "选择达人的社媒平台和内容形式",
    languageTooltip: "输入语言，以便向使用该语言的人群营销",
    postDateTooltip: "如有指定的发布时间窗，请在此设置。",
    benchmarkBrandsDesc: "我们会优先推荐与这些品牌合作过且数据好或受众相近的达人。",
    productIntroPlaceholder: "请简要描述产品核心价值与亮点，简洁有力。",
    businessNamePlaceholder: "请输入品牌/公司名称",
    benchmarkBrandsPlaceholder: "请输入对标品牌",
    // 日期选择器提示
    selectCampaignStartDates:
      "建议至少提前一个月设置开始日期，确保达人有充足时间制作内容。",
    // 平台限制警告
    platformLimitWarning:
      "当前平台选择可能合适的达人数量有限。为提升效果，建议适当增加平台类型。",
    recommend: "我们会推荐与这些品牌合作过或受众相似的达人。",
    // 匹配准确度模态框
    matchingAccuracyModal: {
      switchToFocusMode: "切换到专注模式？",
      switchToMaxScaleMode: "切换到最大规模模式？",
      switchToScaleMode: "切换到规模模式？",
      focusModeDescription: "这将缩小达人池范围以提高匹配精度，可能会增加成本并延长活动周期。最适合高度细分的小众活动。",
      maxScaleModeDescription: "这将扩大达人池范围以帮助降低成本并加速活动执行，但可能会降低整体匹配精度。最适合面向广泛受众的活动。",
      switchToScaleFromFocusDescription: "切换到规模模式将扩大达人池范围，同时保持相关性，在效率、成本和活动速度之间提供平衡。",
      switchToScaleFromMaxScaleDescription: "与最大规模模式相比，这将缩小达人池范围，同时保持相关性——在效率、成本和活动速度之间提供平衡的权衡。",
      confirmSwitch: "确认切换",
      focusModeWarning: "重要提示：切换到专注模式将重新计算达人匹配。一些不再符合条件的现有邀请和申请将被移除。请谨慎操作。",
      scaleModeWarningFromMaxScale: "重要提示：切换到规模模式将重新计算达人匹配。一些不再符合条件的现有邀请和申请将被移除。请谨慎操作。"
    }
  },

  // 活动信息预览页面相关
  campaignInformationPreview: {
    title: "计划信息",
    edit: "编辑",
    campaignName: "计划名称",
    internalNote: "内部备注",
    influencerMarketingBudget: "达人营销预算",
    affiliateRecruitmentBudget: "分销招募预算",
    coldEmailBudget: "邮件营销预算",
    influencerMarketingBudgetTooltip: "您的预算决定了 AI 可以邀请多少达人。如果您希望 AI 匹配更多达人并最大化您的活动效果，请增加预算。",
    country: "国家/地区",
    language: "语言",
    platform: "平台",
    placements: "营销平台选择",
    audienceLinkTitle: "请提供受众点击后跳转的链接",
    affiliateCommissionRate: "分销佣金比例",
    influencerMarketingPostDate: "达人营销发布日期",
    affiliateMarketingPostDate: "分销营销发布日期",
    fixedPostTime: "固定发布时间：达人需在指定时间窗口内发布。",
    flexiblePostTime: "灵活发布时间：达人内容通过后即可发布。",
    affiliatePostTime: "达人申请通过后需在 7 日内发布内容",
    importantMatters: "重要事项",
    campaignResultsEstimation: "活动效果预估",
    estimationDescription: "以下为预测数据，实际结果以最终达人成效为准。",
    businessName: "品牌/公司名称",
    website: "网站",
    benchmarkBrands: "对标品牌",
    productServiceType: "产品/服务类型",
    productIntro: "产品简介",
    productValue: "产品价值",
    coreSellingPoints: "核心卖点",
    coreAudiences: "核心产品受众",
    budgetPerInfluencer: "单个达人预算",
    maximumCpm: "最高 CPM",
  },

  influencerStrategy: {
    title: "达人策略",
    basicInformation: "基础信息",
    campaignBrief: "您分享的产品链接或活动 brief（用于生成达人策略；不会向达人展示）",
    influencerProfiles: {
      title: "达人画像",
      description:
        "用自然语言描述您理想的达人。您也可以根据产品信息、参考达人或对标产品提取画像。",
      regenerate: "优化画像",
      atLeastOneRequired: "请至少添加一个达人画像。",
    },
    wishlist: "白名单",
  },

  unsavedChanges: {
    title: "有未保存的更改",
    description: "您想保存还是放弃这些更改？",
    discard: "放弃",
    saveChanges: "保存更改",
  },

  creatorBrief: {
    title: "达人brief",
  },

  termsAndBudget: {
    title: "活动预算",
    tabLabel: "条款与预算",
    applyUsageRightsChangesTitle: "确认应用使用权变更？",
    applyUsageRightsChangesDesc:
      "这些变更仅适用于您尚未确认的达人。已确认的达人将保留原有条款，因为价格已经协商确定。",
    confirmUpdate: "确认更新",
  },

  // 产品寄送及达人权限
  otherInformationPreview: {
    edit: "编辑",
    productDelivery: "是否寄样",
    iWillShipProduct: "我将寄送样品",
    noShipmentNeeded: "我不寄送样品",
    shipProductDescription:
      "您需要分别向每位达人寄送产品，并在平台提供必要的物流信息。达人收货后将开始创作内容。",
    productName: "产品名称",
    productRetailPrice: "产品零售价",
    productPhoto: "产品图片",
    fileSizeExceed5MB: "文件大小不可超过 5 MB！",
    uploadProductPhotoFailed: "产品照片上传失败",
    pleaseSelect: "请选择",
    pleaseEnterProductName: "请输入产品名称",
    uploadProductPhotos: "上传产品照片",
    uploadPhotoHint: ".JPG、.JPEG 或 .PNG，最大 5MB。",
    pleaseUploadProductPhotos: "请上传产品照片",
    pleaseEnterProductCashValue: "请输入产品零售价",
    productOptionsForInfluencerSelection: "达人选择的产品选项",
    pleaseEnterProductOptions: "请输入达人选择的产品选项",
    optionalGuidanceForInfluencerSelection: "达人选择的可选指南",
    pleaseEnterOptionalGuidance: "请输入达人选择的可选指南",
    addImage: "添加图片",
    addProductOption: "添加产品选项",
    requireCreatorRegistrationDesc: "达人需先在您的产品上注册，再提供其注册邮箱/用户ID以获取访问权限。",
    productOptionsForInfluencerSelectionDesc: "添加达人可以选择的产品选项（例如：尺寸、颜色、容量）",
    optionalGuidanceForInfluencerSelectionDesc: "添加指导帮助达人做出正确选择（例如：尺寸提示、颜色建议）",
  },

  // AI代理列表相关
  aiAgentLists: {
    reviewCampaignInfo: "正在审核本次营销计划信息… 请在 24 小时内提供反馈",
    reviewedCampaignInfo: "已完成活动信息审核，活动已通过",
    matchInfluencers: "从达人库中为您匹配合适的达人",
    matchTikTokInfluencers: "匹配 TikTok 达人",
    matchTikTokBody: "已匹配的 TikTok 达人数：",
    matchYouTubeInfluencers: "匹配 YouTube 达人",
    matchYouTubeBody: "已匹配的 YouTube 达人数：",
    identifyContactInfo: "识别达人联系方式并发送邀请",
    sendInvitesYouTube: "向 YouTube 达人发送邀请",
    sendInvitesYouTubeBody: "已识别 YouTube 达人联系方式，邀请已发送",
    sendInvitesTT: "向 TikTok 达人发送邀请",
    sendInvitesTTBody: "已识别 TikTok 达人联系方式，邀请已发送",
    negotiateInfluencers: "与有意向的达人谈判价格并签订合约",
    negotiateWithInfluencers: "与达人谈判",
    negotiateBody: "部分达人已表示兴趣，AhaCreator 正在为您争取更优价格",
    settleContract: "签订合约",
    settleContractBody: "与已确认价格的达人签订合约",
    influencersApplied:
      "已收到达人的申请。如果您对这些达人有任何反馈，请告诉我们，以便更好地匹配您的需求。",
  },

  // 调整提示相关
  adjustAlert: {
    description:
      "您当前看到的是达人实例。若需正式启动本次营销计划，请立即充值。",
    adjustInputs: "没有看到理想的匹配？试试调受众画像。",
  },

  // 广告活动营销策略标签页相关
  adsCampaignMarketingStrategyTabs: {
    affiliatesMarketing: "分销营销",
    influencerMarketing: "达人营销",
  },

  // 达人列表空状态相关
  creatorListEmpty: {
    ahaPicksMessage: '正在从我们 50,000+ 精选达人池中为您挑选最佳匹配，马上就好！',
    pendingConfirmationStartWith: '请先从 ',
    ahaPicks: 'Aha 精选',
    pendingConfirmationCoreMatchDesc: ' 开始：浏览我们精选的达人并向心仪达人请求报价。达人提交报价后，将出现在「已报价达人」标签页供您审核。',
    pendingConfirmationReachingOut: '我们正在为您联系更多达人。',
    pendingConfirmationOnceConfirm: '达人确认意向并提交报价后，您可以在「已报价达人」标签页中查看并审核。通常需要约 48 小时。',
    noData: '暂无数据',
  },

  // 达人列表相关
  creatorList: {
    ahaPicksConfirmTooltip: "请求报价",
    ahaPicksInvite: "邀请",
    ahaPicksSendOffer: "发送报价",
    ahaPicksSendNewQuote: "发送新报价",
    ahaPicksSendOfferSelectContentType: "选择内容形式",
    ahaPicksSendOfferSelectContentTypeHint: "最多可同时选择两种内容形式",
    ahaPicksSendOfferContentTypeTitle: "{label} 报价",
    ahaPicksContentTypeDesc: {
      instagramReel: "专为品牌推广的 Instagram 短视频",
      instagramCarouselPost: "包含多张品牌图片或视频、可滑动浏览的单条 Instagram 帖子",
      tiktokVideo: "专为品牌定制的 TikTok 视频",
      youtubeDedicated: "完全聚焦品牌推广的独立 YouTube 视频",
      youtubeIntegrated: "在常规内容中自然融入品牌推广的 YouTube 视频",
      linkedinImagePost: "包含品牌视觉、信息图或专业照片的轮播帖子",
      linkedinVideoPost: "介绍或演示品牌的专业视频帖子，如使用场景、专家观点或用户推荐",
      twitterPost: "专为品牌定制的 X 帖子",
    },
    ahaPicksRemoveTooltip: "移除达人",
    depositFundsNow: "立即充值",
    moreInfluencers: "更多达人",
    areWaitingToCollaborate: "正在等待与您合作 — 只需",
    collaborationWithAnyCreator: "与任意达人开启合作",
    or: "或",
    depositYourCampaignBudget: "充值活动预算。",
    unlockFullAccess: "解锁完整访问",
    notSeeingIdealMatches: "没有看到理想的匹配？",
    adjustYourInputs: "试试调整筛选条件",
    ahaPicksAlertCoreMatchPart1: "我们已从 AhaCreator 注册达人池中为您找到目前最匹配的人选，并正在邀请更多达人。达人表达意向并提交报价后，将出现在「",
    ahaPicksAlertQuotedInfluencers: "已报价达人",
    ahaPicksAlertCoreMatchPart2: "」标签页。更多推荐即将上线，敬请期待！",
    ahaPicksAlertDefault: "以下为 AhaCreator 达人池中为您精选的达人。请审核本批达人（请求报价或移除）。完成后我们将持续添加新推荐，已提交报价的达人将出现在「已报价达人」标签页。",
    ahaPicksRemoveModalTitle: "微调活动设置，获得更好匹配",
    ahaPicksRemoveModalContentPart1: "感谢您已审核首批 5 位以上达人。当前通过率为 {pass_rate}%（低于 30%），通常说明我们可以再优化一下设置。您可以",
    ahaPicksRemoveModalContentHighlight: "更新活动信息、达人画像、受众画像或达人筛选条件",
    ahaPicksRemoveModalContentPart2: "，我们将立即刷新推荐。",
  },

  // 达人表格列相关
  creatorTableColumns: {
    name: "姓名",
    aiRecommendationReasons: "AI 推荐理由",
    status: "状态",
    matchingScore: "匹配分",
    language: "语言",
    topAudienceLocations: "主要受众地区",
    targetingGap: "受众说明",
    placement: "营销平台选择",
    bestPrice: "提议价格",
    lastCollab: "上次合作",
    recruitmentCost: "招募成本",
    commissionRate: "佣金比例",
    lowestCpm: "CPM 预估",
    cpm: "CPM",
    medianCpm: "中位CPM",
    brandedContentPredictedViews: "中位观看量",
    publishTime: "发布时间",
    starred: "已加星",
    requestedExtension: "请求延期",
    reviewExtension: "审核延期",
    wantBetterResults: "想要更好的效果？",
    matchingScoreDescription:
      "匹配分展示达人与活动设置的契合度，通常分数越高，结果越好。",
    lowerPrice: "主动降价",
    lowerPriceTooltip: "为表达强烈合作意愿，该达人将报价降至低于平台建议价。",
    higherPriceTooltipTitle: '最终价格确认',
    higherPriceTooltip: '该达人的报价高于平台指导价。我们的AI代理已积极协商并确认这是他们可接受的最低报价。',
    betterOffer: '优质报价',
    betterOfferTooltip: '该达人自愿降低其报价低于通常报价以进行此次合作。',
    addFavoriteTooltip: '添加到收藏',
    removeFromFavoriteTooltip: '移除收藏',
    removeCollaborationTooltip: '移除合作',
    confirmCollaborationTooltip: '确认合作',
    submitShippingInformationTooltip: '提交物流单号',
    reviewScriptTooltip: '审核脚本',
    reviewDraftTooltip: "审核草稿",
    lastUpdateTime: "最后更新时间",
    yourOffer: "你的报价",
    influencerCounter: "达人还价",
    influencerFirstRate: "达人首次报价",
    historicalPriceRange: '历史价格区间',
    historicalPriceRangeTooltip: '基于过往合作估算（非报价）。最终价格以达人提交的报价为准。',
    openingOffer: '您的首次报价',
    requestQuoteOrSendOffer: '请求报价或直接发送报价',
    askedInfluencerToQuoteFirst: '您已要求达人先报价',
    notes: "备注",
    screeningAnswers: "筛选回答",
  },

  // 保留或移除达人弹窗
  keepOrRemoveCreatorModal: {
    title: '这些候选达人不再符合您最新的活动要求，请选择您希望保留的达人。',
    mismatchReason: '不匹配原因',
    okText: '保留所选达人',
    cancelText: '移除所选达人',
    selectedCount: '已选择 {count} 位达人',
  },

  // 达人表格语言选择器相关
  creatorTableSelectorLanguage: {
    allLanguages: "全部语言",
    languages: "语言",
  },

  // 达人表格姓名选择器相关
  creatorTableSelectorName: {
    searchPlaceholder: "搜索达人姓名或账号",
  },

  // 达人表格地区选择器相关
  creatorTableSelectorRegion: {
    allRegions: "全部地区",
    audienceLocations: "受众地区",
    unknown: "未知",
  },

  // 达人表格状态选择器相关
  creatorTableSelectorStatus: {
    allStatus: "全部状态",
    status: "状态",
  },

  // 空状态组件相关
  emptyComponent: {
    enterpriseSetupMessage:
      "您的企业邮箱域名正在配置与预热中，通常需要 7–14 天完成。",
    inviteTheInfluencersYouWantToWorkWith: '邀请您想合作的达人',
    youveChosenToReviewInviteListBeforeSendingInvites: '您已选择在发送邀请前审核邀请列表。为了保持活动顺利进行，请尽快检查邀请列表并确认。',
    checkNow: '立即查看',
    dontWorry: "别担心，",
    activelySendingInvitations: "我们正在积极向达人发送邀请",
    onceConfirmed: "。达人确认后会在这里展示。",
    normallyTakes: "通常该流程大约需要",
    processTime: "24–48 小时",
    toComplete: " 即可完成。特殊情况下可能更久，我们会尽快为您推进。",
    workingHardToFindMatches: "我们正在努力从 50,000+ 精选达人池和超过 500 万达人数据库中为您找到最佳匹配。您的匹配将很快出现在 Aha 精选中。"
  },

  // 邀请列表相关
  invitedList: {
    // 表格列标题
    name: "姓名",
    status: "状态",
    country: "国家/地区",
    language: "语言",
    other: "其他",
    // 全量达人外联提示
    fullOutreachLive: "您的活动已开启全量达人外联 — 请关注高质量的申请！",
    // 试用版提示
    depositFundsNow: "立即充值",
    moreInfluencersWaiting: "更多达人正在等待与您合作 — 如需解锁完整访问，只需",
    collaborationWithCreator: "与任意达人开启合作",
    or: "或",
    depositCampaignBudget: "充值活动预算。",
    unlockFullAccess: "解锁完整访问",
    // 调整提示
    notSeeingIdealMatches: "没有看到理想的匹配？",
    adjustYourInputs: "试试调整筛选条件",
    // 确认邀请列表相关
    confirmInviteList: {
      confirmDeleteTitle: "确认移除达人？",
      confirmDeleteTitleMultiple: "确认移除达人？",
      confirmDeleteContent: "您即将移除 1 位达人。一旦移除，他们将不再收到邀请或参与此次合作。此操作无法撤销。请仔细审查后再继续。",
      confirmDeleteContentMultiple: "您即将移除 {count} 位达人。一旦移除，他们将不再收到邀请或参与此次合作。此操作无法撤销。请仔细审查后再继续。",
      inviteSentSuccessSingle: `已成功向 1 位达人发送邀请！达人申请活动后，您可以在"合作管理"页面找到他们`,
      inviteSentSuccessMultiple: `已成功向 {count} 位达人发送邀请！达人申请活动后，您可以在"合作管理"页面找到他们`,
      selectCurrentPage: "选择当前页",
      confirmAllInvitations: "确认所有邀请",
      confirmInvite: "确认邀请",
      emptyStateMessage: "AhaCreator 正在努力为您审核达人。申请审核完成后，达人将显示在此处。",
      confirmAllInvitationsContent: "您即将向 {count} 位达人发送邀请。一旦发送，此操作无法撤销。请仔细审查后再继续。",
      confirmAllInvitationsTitle: "确认发送邀请？"
    }
  },

  // 企业解决方案模板模态框相关
  modalEnterpriseSolutionTemplates: {
    title: "邀请邮件模板示例",
    description: "这些模板经过上千次实验验证，能有效提升转化率。",
    templateNumber: "模板",
    subject: "主题：",
    emailBody: "正文：",
  },

  // 平台过滤器相关
  platformFilter: {
    allPlatforms: "全部平台",
    platforms: "平台",
  },

  // 达人画像过滤器相关
  influencerProfileFilter: {
    placeholder: "达人画像",
    label: "达人画像",
  },

  // 待办事项列表相关
  todoList: {
    title: "待办事项",
    all: "全部",
    congratulations: "恭喜！本次活动暂无待办。",
  },

  // 图表报告相关
  chartsReport: {
    // 分组选项标签
    audience: "受众",
    platform: "平台",
    creative: "创意",
    // 空状态提示
    noDataYet: "暂无数据",
    // 视图选择
    viewBy: "查看维度",
    // 选择器占位符
    selectPerson: "选择人员",
    influencerProfile: "达人画像",
  },

  // 报告页面相关
  reports: {
    // 标题和标签
    campaignPerformance: "整体表现",
    report: "报告",
    watchTutorial: "观看教程",
    // 报告类型
    campaign: "营销计划",
    influencer: "每个达人",
    // 操作按钮
    download: "下载",
    // 已发布内容
    publishedContent: "已发布内容",
    noPublishedContentYet: "暂未发布内容",
    // 其他标签
    for: "周期",
    // 表格列标题
    creatorName: "达人姓名",
    orderValue: "订单金额",
    commissionValue: "佣金金额",
    orderPlacementTime: "下单时间",
    commissionDueTime: "佣金到期时间",
    paymentTime: "付款时间",
    status: "状态",
    pay: "支付",
    adsCode: "广告码",
    languages: "语言",
    allLanguages: "全部语言",
    postViewRange: "帖子浏览量范围",
    minimum: "最小值",
    maximum: "最大值",
    minimumPostViews: "最小帖子浏览量",
    maximumPostViews: "最大帖子浏览量",
    maximumCpm: "最高 CPM",
    maximumCpc: "最高 CPC",
    noLimit: "无限制",
    resetAll: "重置全部",
    inviteAgainCount: "再次邀请（{count}）",
    action: "操作",
  },

  // 付款模态框相关
  paymentModal: {
    // 标题
    title: "付款详情",
    // 付款详情
    commissionAmount: "佣金金额",
    transactionFee: "交易手续费",
    transactionFeeDescription: "手续费取决于您的支付方式，由支付服务商收取。",
    freeCredits: "免费额度",
    total: "总计",
    // 按钮和操作
    confirmAndPay: "确认并支付",
    setup: "去设置",
    notNow: "暂不操作",
    // 错误和警告
    paymentFailed: "支付失败，请重试。",
    noAvailablePaymentMethod: "暂无可用支付方式",
    noPaymentMethodContent: "请先充值余额或绑定银行卡后，再确认达人。",
    // 安全提示
    guaranteedSafe: "安全可靠的支付保障",
    poweredBy: "技术支持",
  },

  // 报告表格相关
  reportTable: {
    actual: "现状",
  },

  // 报告表格头部相关
  reportTableHeader: {
    // 时间相关
    startedOn: "开始于",
    campaignPeriod: "活动周期",
    reportUpdateDate: "报告更新时间",
    // 其他信息
    objective: "目标",
    cost: "花费",
  },

  // 报告表格选择器相关
  reportTableSelector: {
    // 受众选择器
    allAudiences: "全部达人画像",
    pleaseSelect: "请选择",
    // 创意选择器
    allCreatives: "全部创意",
    // 平台选择器
    allPlatforms: "全部平台",
    // 国家选择器
    allCountries: "全部国家",
    selectPublishedAt: "发布开始时间",
    selectPublishedAtEnd: "发布结束时间",
  },

  // 销售外联页面相关
  salesOutreach: {
    // 页面标题
    title: "邮件营销",
    // 表格列标题
    email: "邮箱",
    name: "姓名",
    profileHeadline: "个人简介",
    status: "状态",
    emailReply: "邮件回复",
    price: "价格",
    // 状态标签
    leadForwarded: "线索已转交",
    converted: "已转化",
    // 操作按钮
    pay: "支付",
    paid: "已支付",
    // 统计信息
    leadsPurchased: "已购线索",
    totalSent: "已发送",
    openRate: "打开率",
    replyRate: "回复率",
    convertedCount: "转化数量",
    totalQualifiedLeads: "数据库合格线索总数：",
    addMoreLeads: "添加更多线索",
    // 空状态提示
    emailWarmingUp: "邮箱预热中，约需 7 天以确保最佳外联效果。",
    emailTemplatesLeverage:
      "我们的邮件模板已被验证，累计为 300+ 企业带来 20,000+ 高质量线索",
  },

  // 添加更多线索模态框相关
  addMoreLeads: {
    // 模态框标题
    title: "添加更多线索",
    // 描述文本
    description: "还有 {availableLeads} 个合格线索可用。请输入您要添加的数量。",
    // 输入框占位符
    placeholder: "请输入购买的线索数量",
    // 错误提示
    numberMustBeGreaterThanZero: "数量必须大于 0！",
    enterNumberSmallerThan: "请输入小于 {availableLeads} 的数量！",
    // 按钮文本
    cancel: "取消",
    proceedToPayment: "去支付",
  },

  // 邮件详情组件相关
  emailDetails: {
    // 按钮文本
    payToUnlock: "支付后解锁此转化线索",
  },

  // 邮件付款模态框相关
  emailPaymentModal: {
    // 默认标题
    defaultTitle: "邮件营销付款详情",
    // 费用项目
    coldEmailInfra: "邮件营销基础服务",
    enterpriseSolutionCost: "企业方案费用",
    transactionFee: "交易手续费",
    freeCredits: "免费额度",
    total: "总计",
    // 费用说明
    coldEmailInfraDesc: "包含域名搭建、邮箱预热、外联等基础成本。",
    enterpriseSolutionDesc: "包含自定义域名搭建、定制推广链接等费用。",
    transactionFeeDesc: "手续费取决于您的支付方式，由支付服务商收取。",
    // 按钮文本
    confirmAndPay: "确认并支付",
    // 安全提示
    guaranteedSafe: "安全可靠的支付保障",
    poweredBy: "技术支持",
    // 错误和警告
    paymentFailed: "支付失败，请重试。",
    // 原始价格（划线价格）
    originalPrice: "原价",
  },

  inviteAgain: {
    trigger: "再次邀请",
    reinvited: "已再次邀请",
    historyAction: "再次邀请历史",
    historyTitle: "邀请历史",
    closeHistory: "关闭邀请历史",
    invitationSent: "第 {number} 次邀请",
    inviteTime: "邀请时间",
    campaignLabel: "活动",
    viewOrder: "查看订单",
    details: "详情",
    collaborateAgain: "再次合作",
    selectedCreators: "已选择 {count} 位达人",
    title: "再次邀请",
    subtitle:
      "将与 {creatorName} 的新合作添加到一个现有 Campaign，或创建新的 Campaign。",
    mobileStepCampaign: "第 1 步，共 2 步 · 选择 Campaign",
    mobileStepOffer: "第 2 步，共 2 步 · 报价详情",
    selectCampaign: "选择 Campaign",
    selectCampaignDescription:
      "将与 {creatorName} 的新合作添加到一个现有 Campaign，或创建新的 Campaign。",
    searchPlaceholder: "搜索 Campaign 名称",
    createCampaign: "创建新的 Campaign",
    createCampaignDescription: "系统将自动把该达人加入心愿单。",
    loadingCampaigns: "正在搜索 Campaign...",
    searchingCampaigns: "正在搜索 Campaign...",
    noCampaignsFound: "未找到 Campaign",
    noCampaignsDescription:
      "没有找到匹配的 Campaign。您可以创建新的 Campaign 并添加该达人。",
    newCampaign: "新建 Campaign",
    internalNote: "内部备注：{note}",
    budgetSpent: "已花费 {cost} / {limit}",
    campaignBudget: "Campaign 预算：{budget}",
    pricingTitle: "发送报价或邀请达人报价",
    pricingDescription: "选择与 {creatorName} 开始此次合作的方式。",
    sendOffer: "发送报价",
    sendOfferDescription:
      "随邀请发送报价，{creatorName} 可以接受、还价或拒绝。",
    selectDeliverables: "选择合作内容",
    offerLabel: "{contentType} 报价",
    contentTypeDescriptions: {
      youtubeDedicated: "专门为品牌定制的 YouTube 独立推广视频。",
      youtubeIntegrated: "在日常内容中自然融入品牌或产品的视频。",
      tiktokVideo: "一条专门为您的品牌制作的 TikTok 视频。",
      instagramReel: "一条专门为您的品牌制作的 Instagram Reels 短视频。",
      instagramCarouselPost:
        "一条包含多张品牌图片或视频、支持滑动浏览的 Instagram 帖子。",
      linkedinImagePost: "一条展示您品牌的 LinkedIn 图片或轮播帖子。",
      linkedinVideoPost: "一条展示您品牌的 LinkedIn 专业视频。",
      twitterPost: "一条专门为您的品牌制作的 X 帖子。",
    },
    messageLabel: "给达人的消息（可选）",
    messagePlaceholder:
      "说明您的原因（预算限制、交付内容更简单等），并提及未来合作机会",
    nonNegotiable: "将此价格设为固定价格（不可议价）",
    nonNegotiableDescription: "开启后，达人只能接受或拒绝。",
    requestQuote: "邀请达人报价",
    requestQuoteDescription:
      "不提供价格直接邀请 {creatorName}，由达人先报价，之后您可以接受、还价或拒绝。",
    cancel: "取消",
    back: "返回",
    continue: "继续",
    addToCampaign: "添加到 Campaign",
    success: "邀请已成功发送。",
    loadCampaignsFailed: "无法加载进行中的 Campaign。",
    loadHistoryFailed: "邀请历史加载失败，请重新打开历史抽屉重试。",
    createCampaignFailed: "创建 Campaign 失败。",
    submitFailed: "添加此次合作失败。",
  },

  collaborationCancellation: {
    status: {
      influencerEnded: "达人已结束合作",
      tooltip: "达人选择结束本次协商。",
    },
    list: {
      viewDetails: "查看详情",
    },
    reasons: {
      personalCircumstances: "个人原因导致我无法继续",
      contentRequirementsExpanded: "内容要求比我预期的更多",
      paymentNoLongerWorks: "当前付款条件不再适合我",
      needMoreTime: "我需要更多时间",
      productOrShippingIssue: "产品或物流存在问题",
      other: "其他",
    },
    drawer: {
      title: "达人已取消合作",
      summary: "该达人已取消本次合作。请查看取消原因、合作进度和款项信息。",
      reason: "取消原因",
      notes: "补充说明",
      submittedOn: "提交时间",
      accountabilityApplied: "平台将对达人进行信用处理",
      accountabilityAppliedDescription:
        "本次取消被认定为达人自身原因。AhaCreator 已按照平台规则扣减该达人的平台信用分，并将本次行为记录至其履约表现。该记录将影响达人后续的Rating 与合作机会，以减少类似取消再次影响广告主。",
      refundCompleted: "款项已退回",
      refundCompletedAmountDescription:
        "{amount}退款已退回至您的{destination}",
      refundAmount: "退款金额",
      returnedTo: "退回账户",
      brandAccount: "AhaCreator 广告主账户",
      refundSourceBalance: "账户可用余额",
      refundSourceCard: "银行卡",
      refundSourceCardEnding: "{brand}（尾号 {last4}）",
      refundSourceSeparator: "、",
      refundSourceLastSeparator: "及",
      completedOn: "退款时间",
      creditedImmediately: "确认后立即入账",
      viewMore: "查看账户明细",
      report: "申诉",
      reportSubmitted: "申诉已提交",
      loadFailed: "取消详情加载失败。",
      retry: "重试",
      gotIt: "知道了",
    },
    report: {
      title: "达人提交的原因有误",
      description:
        "经核实后，我们将根据平台规则扣减该达人的平台信用分，并将此行为记录在其履约记录中。该记录会影响达人后续的评分和合作机会，从而降低类似取消行为再次对广告主造成的影响。",
      fieldLabel: "实际发生了什么？",
      placeholder: "请说明该取消原因不准确的原因",
      submitSuccess: "您的申诉已提交审核。",
      submitFailed: "反馈提交失败，请稍后重试。",
    },
    timeline: {
      detailsTitle: "取消详情",
      reason: "取消原因",
      notes: "补充说明",
      accountabilityApplied:
        "AhaCreator 已记录本次达人主动取消，并采取了相关账户措施。",
      refunded: "{amount} 已退回您的{destination}。",
      brandAccount: "AhaCreator 品牌账户",
      cancelledOn: "取消时间：",
    },
  },

  // 议价提案相关
  proposedRate: {
    counter: "提交还价",
    negotiationPrice: "议价记录",
    makeACounterOffer: "议价记录",
    influencerMessage: "达人消息",
    brandMessage: "品牌消息",
    submitMyProposal: "提交我的报价",
    submitMyRate: "提交我的报价",
    sameAmountTitle: "提交相同金额？",
    sameAmountDescription: "您的报价与达人的最新报价相同。是否仍要提交？",
    editOffer: "编辑报价",
    submitAnyway: "仍然提交",
    yourCounterOffer: "你的报价",
    yourLatestQuote: "你的最新报价",
    yourLatestQuoteDesc: "你的最新报价正在被达人审核。你可以提交一个新的报价让达人审核。",
    price: "价格",
    editPrice: "编辑价格",
    medianViews: "播放量中位数",
    medianCpm: "CPM 中位数",
    lastCollab: "上次合作",
    belowCreatorBaselineRate: "低于该达人的承诺基础价格",
    belowCreatorBaselineRateDesc: "继续之前，请解释为什么这个低于达人基础价格的报价应该被考虑。",
    explanation: "说明",
    explanationPlaceholder: "帮助达人理解为什么这个报价应该被认为低于他们的承诺价格，例如最小的生产工作量、灵活的交付时间表等。",
    messageToInfluencer: "给达人的消息 (可选)",
    messagePlaceholder: "分享你的理由 (预算限制, 更简单的交付) 并提及未来的合作机会",
    nonNegotiableTooltip: "该达人的报价不可议价。",
    nonBrandNegotiableTooltip: "你已设置本次报价“不可协商”。达人可以接受或拒绝，但不能进一步协商。",
    negotiatedPriceTooltip: "该达人可议价",
    newLabel: "新功能！",
    nonNegotiableCheckbox: "若您的报价不可议价，请勾选此项。勾选后，达人只能同意或拒绝，请谨慎操作。",
    explanationRequired: "解释说明必填",
    warningAlert: "该报价明显低于达人的报价。更接近达人的报价的报价更容易被接受。",
    errorAlert: "报价与达人的报价差距过大，可能被拒绝。",
    priceHistory: "价格历史",
    negotiationRecords: '议价记录',
    negotiationHistory: '议价历史',
    makeOfferNonNegotiable: "将此报价设为不可议价",
    makeOfferNonNegotiableDesc: "达人只能接受或拒绝此报价。",
    brandOffer: "广告主出价",
    brandQuote: "品牌报价",
    influencerQuote: "达人报价",
    influencerLatestQuote: "达人最新报价",
    minPriceError:
      "已高于{influencerName}的报价 {maxPrice}，无需出价更高。请输入不超过 {maxPrice} 的金额。",
    allowedRangeError:
      "请输入介于您上次报价（{lastOfferPrice}）与{influencerName}最新报价（{influencerQuotePrice}）之间的金额。",
    belowMinPriceError: "输入值必须大于 {minPrice}",
    belowFairRangeAlert: "您的报价低于公允价格区间，达人可能会拒绝或还价。",
    withinFairRangeAlert: "您的报价处于公允价格区间内，较平衡的报价，成交概率较高。",
    aboveFairRangeAlert: "高于同类达人的公允价格。建议确认预算承受范围后酌情考虑。",
    fairRangeTooltip: "公允价格区间是与该达人合作的市场参考价。它基于类似达人的近期合作数据估算，综合考虑其受众、领域、频道表现（如平均播放量、粉丝数）以及该达人与您品牌的契合度。在此区间内报价有助于提高成交概率。",
    fairRangeEstimateLink: "我们如何估算公允价格区间",
    fairRangeDrawerDescription: "公允价格区间是此次合作的市场参考价。它基于类似达人的近期合作数据估算，综合考虑您的受众、领域、频道表现（如平均播放量、粉丝数）以及您与品牌的契合度。在此区间内定价既能确保您获得与作品价值相符的报酬，也能最大程度提高达成合作的机会。",
    nonNegotiableLabel: "不可议价",
    nonNegotiableAlert: "该报价不可议价，您只能接受或拒绝。",
    creatorNonNegotiableAlert:
      "达人将此报价设为不可议价。您只能接受或拒绝，无法还价。",
    brandNonNegotiableAlert:
      "您将此报价设为不可议价。达人只能接受或拒绝，无法还价。",
    influencerFixedRate: "达人固定报价",
    brandFixedRate: "广告主固定报价",
    belowFairRangeLabel: "低于公允区间",
    withinFairRangeLabel: "处于公允区间",
    withinFairRangeLowLabel: "公允区间低端",
    withinFairRangeHighLabel: "公允区间高端",
    aboveFairRangeLabel: "高于公允区间",
    creatorBelowFairRangeTooltip: "低于市场公允价格区间，通常说明达人很看好您的品牌。这是一笔不错的交易，建议接受。",
    creatorWithinFairRangeLowTooltip: "定价合理，可以直接接受。",
    creatorWithinFairRangeHighTooltip: "处于公允价格区间内，是一笔值得接受的交易。是否进一步议价由您决定。",
    creatorAboveFairRangeTooltip: "高于市场公允价格区间，建议在决定前仔细考虑。",
    viewDetails: "查看详情",
  },

  // 报价上限相关
  rateCap: {
    overYourCap: "价格上限外",
    overUnitPriceCap: "超出单价上限：{cap}",
    overCpmCap: "超出 CPM 上限：{cap}",
    farAboveMarket: "远高于市场价",
    withinRateCap: "符合要求",
    overRateCap: "报价超上限",
    audienceGap: "受众有偏差",
    overRateCapAlert: "高匹配度达人报价略高于您的单价/CPM 上限。批准以达成合作，或跳过。",
    audienceGapAlert: "这些达人申请时表现出强烈兴趣，但其受众仅部分匹配您的目标受众。请查看以下受众缺口，然后酌情批准或拒绝。",
  },
};
